module.exports = __webpack_public_path__ + "media/images/parking sécurisé-054b2e463fa3c05f10ee09eb1679357e.svg";